/* tslint:disable:max-line-length */
export const getInterfaceWrongDomainErrorMsg = () => 'Interface domain is not provided or has wrong type!';
export const getInterfaceNoMethodsErrorMsg = (interfaceName: string) =>
  `Interface ${interfaceName} does not have any methods or events defined!`;
export const getMethodTooManyArgsErrorMsg = (methodName: string) =>
  `Service method ${methodName} has too many arguments!`;
export const getMethodUnexpectedArgsErrorMsg = (domain: string, serviceName: string, methodName: string) =>
  `Unexpected arguments number for ${domain}.${serviceName}.${methodName}!`;
export const getMetaMissingFunctionsErrorMsg = (serviceName: string, objName: string, missingFunctions: string[]) =>
  `Invalid service ${serviceName} metadata: ${objName} is missing ${missingFunctions.join(', ')} functions`;
